<style lang="scss" src='./WeatherStations.scss' scoped></style>
<template src="./WeatherStations.html"></template>

<script>
import SecurityComponent from '@/components/SecurityComponent.vue';
import GwExport from '@/components/gwExport/GwExport.vue';
import ApexChart from 'vue-apexcharts';
import VueHtml2pdf from 'vue-html2pdf';
import moment from 'moment';
import XLSX from 'xlsx';
import Datepicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import {
    getWeatherStationsReportList,
    getWeatherStationsReportGraphData,
    getAllWeatherStationsReportList,
    getAllWeatherStationsReportGraphData,
    getStationGraph
} from '@/api/index';

import i18n from './../../../../i18n';
import MapStation from '@/assets/img/ic/ico_marker_station.png';

let CounterForUpdatesLines = 0;
let stationsArray = [];
let validStations = [];
let allReadingsArray = [];

const perPage = 100;
const pdfMaxWidth = 1120;
const chartWidth12 = "1050px";
const chartWidth6 = "500px";
const chartWidth4 = "350px";

export default {
    name: 'WeatherStations',
    extends: SecurityComponent,
    components: {
        ApexChart,
        VueHtml2pdf,
        GwExport,
        Datepicker
    },
    data() {
        return {
            all: false,
            map: {},
            google: {},
            chartMaxWidth12: '100%',
            chartMaxWidth6: '100%',
            chartMaxWidth4: '100%',
            selectedDateRange: null,
            stickyData: true,
            isOperationsOrAdminUser: false,
            pdfName : null,
            loading: {
                map: false,
                general: false,
                stations: false,
                temp: false,
                pressure: false,
                wind_speed: false,
                lightning_strike: false,
                precipitation: false,
                humidity: false,
                wind_gust: false,
                et_rate: false,
            },
            filters: {
                daysBack: null,
                zones: []
            },
            markers: [],
            stations: [],
            loadedSensorsArray: [],
            allSensorsLength: 0,
            allStations: [],
            stationsLength: 0,
            temp_series: [],
            pressure_series: [],
            wind_speed_series: [],
            lightning_strike_series: [],
            precipitation_series: [],
            humidity_series: [],
            wind_gust_series: [],
            et_rate_series: [],
            options: [
                { text: this.$t('timePeriods.1DLong'), label: this.$t('timePeriods.last24H'), value: 1, },
                { text: this.$t('timePeriods.2DLong'), label: this.$t('timePeriods.last2D'), value: 2, },
                { text: this.$t('timePeriods.1WLong'), label: this.$t('timePeriods.lastWeek'), value: 7, },
                { text: this.$t('timePeriods.1MLong'), label: this.$t('timePeriods.lastMonth'), value: 30, },
                { text: this.$t('timePeriods.1YLong'), label: this.$t('timePeriods.lastYear'), value: 365, },
                { text: 'By Date', label: 'By Date', value: 0, }, 
            ],
            temperatureCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            pressureCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            windSpeedCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            lightningStrikeCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            precipitationCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            humidityCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            windGustCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            etRateCharOpt: {
                xaxis: {
                    type: 'datetime',
                },
            },
            pagination: {
                page: 1,
                start: 0,
                end: 0
            },
            pdf: {},
        };
    },
    computed: {
        getStations() {
            return this.stations;
        },
        canGetNextPage(){
            return this.pagination.page * perPage < this.stationsLength;
        },
        getFilteredStations(){
            let series = this.allStations.filter((r) => r.selected);
            if(series.length == 0 || this.all){
                series = stationsArray;
            }
            
            this.stationsLength = series.length;
            this.stations = series;
            return this.getStationsByPage();
        },
        getFilteredTempSeries(){
            let filteredStations = this.allStations.filter((r) => r.selected);
            if(filteredStations.length == 0 || this.all){
                return this.temp_series;
            }else{
                let series = []
                for(var i = 0; i < this.temp_series.length; i++){
                    for(var j = 0; j < filteredStations.length; j++){
                        if(this.temp_series[i].device_sn == filteredStations[j].device_sn){
                            series.push(this.temp_series[i]);
                        }
                    }
                }
                return series;
            }
        },
        getFilteredPressureSeries(){
            let filteredStations = this.allStations.filter((r) => r.selected);
            if(filteredStations.length == 0 || this.all){
                return this.pressure_series;
            }else{
                let series = []
                for(var i = 0; i < this.pressure_series.length; i++){
                    for(var j = 0; j < filteredStations.length; j++){
                        if(this.pressure_series[i].device_sn == filteredStations[j].device_sn){
                            series.push(this.pressure_series[i]);
                        }
                    }
                }
                return series;
            }
        },
        getFilteredWindSpeedSeries(){
            let filteredStations = this.allStations.filter((r) => r.selected);
            if(filteredStations.length == 0 || this.all){
                return this.wind_speed_series;
            }else{
                let series = []
                for(var i = 0; i < this.wind_speed_series.length; i++){
                    for(var j = 0; j < filteredStations.length; j++){
                        if(this.wind_speed_series[i].device_sn == filteredStations[j].device_sn){
                            series.push(this.wind_speed_series[i]);
                        }
                    }
                }
                return series;
            }
        },
        getFilteredLigthningStrikeSeries(){
            let filteredStations = this.allStations.filter((r) => r.selected);
            if(filteredStations.length == 0 || this.all){
                return this.lightning_strike_series;
            }else{
                let series = []
                for(var i = 0; i < this.lightning_strike_series.length; i++){
                    for(var j = 0; j < filteredStations.length; j++){
                        if(this.lightning_strike_series[i].device_sn == filteredStations[j].device_sn){
                            series.push(this.lightning_strike_series[i]);
                        }
                    }
                }
                return series;
            }
        },
        getFilteredPrecipitationSeries(){
            let filteredStations = this.allStations.filter((r) => r.selected);
            if(filteredStations.length == 0 || this.all){
                return this.precipitation_series;
            }else{
                let series = []
                for(var i = 0; i < this.precipitation_series.length; i++){
                    for(var j = 0; j < filteredStations.length; j++){
                        if(this.precipitation_series[i].device_sn == filteredStations[j].device_sn){
                            series.push(this.precipitation_series[i]);
                        }
                    }
                }
                return series;
            }
        },
        getFilteredHumiditySeries(){
            let filteredStations = this.allStations.filter((r) => r.selected);
            if(filteredStations.length == 0 || this.all){
                return this.humidity_series;
            }else{
                let series = []
                for(var i = 0; i < this.humidity_series.length; i++){
                    for(var j = 0; j < filteredStations.length; j++){
                        if(this.humidity_series[i].device_sn == filteredStations[j].device_sn){
                            series.push(this.humidity_series[i]);
                        }
                    }
                }
                return series;
            }
        },
        getFilteredWindGustSeries(){
            let filteredStations = this.allStations.filter((r) => r.selected);
            if(filteredStations.length == 0 || this.all){
                return this.wind_gust_series;
            }else{
                let series = []
                for(var i = 0; i < this.wind_gust_series.length; i++){
                    for(var j = 0; j < filteredStations.length; j++){
                        if(this.wind_gust_series[i].device_sn == filteredStations[j].device_sn){
                            series.push(this.wind_gust_series[i]);
                        }
                    }
                }
                return series;
            }
        },
        getFilteredETRateSeries(){
            let filteredStations = this.allStations.filter((r) => r.selected);
            if(filteredStations.length == 0 || this.all){
                return this.et_rate_series;
            }else{
                let series = []
                for(var i = 0; i < this.et_rate_series.length; i++){
                    for(var j = 0; j < filteredStations.length; j++){
                        if(this.et_rate_series[i].device_sn == filteredStations[j].device_sn){
                            series.push(this.et_rate_series[i]);
                        }
                    }
                }
                return series;
            }
        },
        allSensorsLoaded(){
            return this.loadedSensorsArray.length > 0 && this.loadedSensorsArray.length == stationsArray.length;
        },
    },
    methods: {
        getCourseName (ws) {
            if ('multiple' in ws){
                if(ws.multiple){
                    return this.$t('reports.multipleFacilities');
                }
                //console.log(ws)
                if('course' in ws && ws.course && ws.course.course_id){
                    return ws.course.name; 
                }
            }

            return '';

        },

        async initMap() {

            const mapOptions = {
                mapId: 'setMap',
                zoom: 2,
                center: {
                    lat: 0,
                    lng: 0,
                },
                controlOptions: {
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                },
            };

            this.map = await this.G_initMap(mapOptions);
            this.google = this.consts.Google.MAP;
        },

        stationMap() {
            if (validStations.length > 0) {
                
                if (this.markers.length) {
                    this.markers.forEach((m) => {
                        m.setMap(null);
                    });
                }
                
                let center = {
                    lat: validStations[0].lat,
                    lng: validStations[0].lng,
                };
                
                if (validStations.length > 1) {
                    const features = window.turf.featureCollection(
                        validStations.map((o) => window.turf.point([o.lat, o.lng])),
                    );
                    
                    const gemetryCenter = window.turf.center(features);
                    if (gemetryCenter.geometry && gemetryCenter.geometry.coordinates) {
                        center = {
                            lat: gemetryCenter.geometry.coordinates[0],
                            lng: gemetryCenter.geometry.coordinates[1],
                        };
                    }
                }
                
                this.setMap(center, 18);

            } else {
                this.initMap();
            }
        },

        setMap(center, zoom) {
            if (this.map && this.google && this.google.maps) {
                
                var latlngList = [];
                
                this.markers = validStations.map((m) => {
                    latlngList.push(new this.google.maps.LatLng(m.lat, m.lng));
                    
                    const infoWindow = new this.google.maps.InfoWindow({
                        content: `
                            <h5 class='d-flex align-items-center '> ${m.name} </h5>
                            <table>
                                <tr>
                                <td class='text-right'>${this.$t('weatherStation.stations')}: </td>
                                <td class='text-left'>${m.device_sn}</td>
                                </tr>
                            </table>`,
                    });

                    const icon = {
                        url: MapStation,
                        scaledSize: new google.maps.Size(100, 75),
                    }

                    const newMark = new this.google.maps.Marker({
                        infoWindow,
                        stationId: m.station_id,
                        position: m,
                        icon
                    });

                    newMark.setMap(this.map);
                    
                    newMark.addListener('click', () => {
                        if(!newMark.open){
                            infoWindow.open(this.map, newMark);
                            newMark.open = true;
                        } else {
                            infoWindow.close();
                            newMark.open = false;
                        }
                    });
                    
                    return newMark;
                });

                var bounds = new this.google.maps.LatLngBounds();
                
                latlngList.map((n) => {
                    bounds.extend(n);
                });
                
                this.map.setCenter(bounds.getCenter());
                this.map.fitBounds(bounds);
                this.map.setZoom(this.map.getZoom() - 1);
                
                if (this.map.getZoom() > 18) {
                    this.map.setZoom(18);
                }
                
            } else {
                setTimeout(() => {
                    this.setMap(center, zoom);
                }, 10);
            }
        },

        onClick(ev, index) {
            if (index > -1) {
                if (this.all) {
                    this.all = false;
                }
                this.onSelect(this.allStations.filter((r) => r.selected));
            } else {
                this.selectAllFilteredStations(ev);
            }

            let series = this.allStations.filter((r) => r.selected);
            if(series.length == 0 || this.all){
                series = stationsArray;
            }
            this.stationsLength = series.length;
            this.stations = series;
            this.pagination.start = 1;
            this.pagination.page = 1;
            this.pagination.end = (this.stationsLength >= perPage) ? perPage : this.stationsLength;
        },

        onSelect(stations) {
            if (stations && stations.length) {
                
            }
        },

        selectAllFilteredStations(selected) {
            this.allStations.forEach((s) => {
                s.selected = selected;
            });
        },

        getCsvData(){
            return [];
        },

        csvExport() {
            let csvContent = "data:text/csv;charset=utf-8,";
            let arrData = this.getCsvAllData();
            if(arrData.length > 0){
                csvContent += [
                    Object.keys(arrData[0]).join(","),
                    ...arrData.map(item => Object.values(item).join(","))
                ]
                    .join("\n")
                    .replace(/(^\[)|(\]$)/gm, "");

                const data = encodeURI(csvContent);
                const link = document.createElement("a");
                link.setAttribute("href", data);
                link.setAttribute("download", this.pdfName + ".csv");
                link.click();
            }
        },

        xlsxExport() {
            let readings = allReadingsArray;
            if(readings.length>0){
                var new_workbook = XLSX.utils.book_new();
                let headers = [];
                let filters = this.getXLSXHeadersObj();
                headers.push(filters);

                var worksheet = XLSX.utils.json_to_sheet(headers);
                XLSX.utils.book_append_sheet(new_workbook, worksheet, "Filters");


                let data = [];
                let currentStation = '';

                readings.forEach((item)=>{
                    let filteredStations = this.allStations.filter((r) => r.selected);
                    if(filteredStations.length == 0 || this.all){
                        filteredStations = stationsArray;
                    }

                    let station = filteredStations.find((t) => t.station_id == item.station_id);

                    if(station && station.station_id && item.data && item.data.length > 0){

                        let readings_array = item.data.map( (reading) => {
                            let obj = {}
                            obj[i18n.t('general.name')] = station.name;
                            obj[i18n.t('weatherStation.serialNumber')] = station.device_sn;
                            
                            if(this.G_canDo(this.consts.Security.Action.SEE_LAST_READING, this.$store.state.user, null)){
                                obj[i18n.t('facility.facility')] = this.getCourseName(station);
                                let reading_date = this.G_formatDate({date: (reading.reading_time), pretty: false});
                                obj[i18n.t('general.date')] = reading_date ? reading_date.replace(/,/g, "") : reading_date;
                            }
                            
                            let temperature = this.G_getMeasurement({ val: reading.temp, uom: this.consts.UOM.TEMP, addUnit: true, invertUOM: false })
                            obj[i18n.t('alerts.airTemperature')] = temperature.replace('°', '');
                            obj[i18n.t('alerts.barometricPressure')] = this.G_getMeasurement({ val: reading.pressure, uom: this.consts.UOM.PRESSURE, addUnit: true, invertUOM: false });;
                            obj[i18n.t('alerts.vhStrike')] = this.G_getMeasurement({ val: reading.lightning_strike, uom: this.consts.UOM.UNKNOWN, addUnit: true, invertUOM: false });;
                            obj[i18n.t('alerts.precipitation')] = this.G_getMeasurement({ val: reading.precipitation, uom: this.consts.UOM.PRECIPITATION, addUnit: true, invertUOM: false });;
                            obj[i18n.t('alerts.relativeHumidity')] = this.G_getMeasurement({ val: reading.humidity, uom: this.consts.UOM.HUMIDITY, addUnit: true, invertUOM: false });;
                            obj[i18n.t('alerts.horizontalWindSpeed')] = this.G_getMeasurement({ val: reading.wind_speed, uom: this.consts.UOM.WIND_SPEED, addUnit: true, invertUOM: false });;
                            obj[i18n.t('alerts.windGust')] = this.G_getMeasurement({ val: reading.wind_gust, uom: this.consts.UOM.WIND_SPEED, addUnit: true, invertUOM: false });;
                            obj[i18n.t('alerts.eTRate')] = this.G_getMeasurement({ val: reading.et_rate, uom: this.consts.UOM.ET_RATE, addUnit: true, invertUOM: false });;
                            return obj;
                        });

                        if(currentStation != station.device_sn && data.length > 0){
                            let new_worksheet = XLSX.utils.json_to_sheet(data);
                            XLSX.utils.book_append_sheet(new_workbook, new_worksheet, currentStation);
                            data = [];
                        }

                        currentStation = currentStation != station.device_sn ? station.device_sn : currentStation;
                        
                        if(readings_array.length > 0){
                            data = data.concat(readings_array);
                        }
                    }
                });

                if(currentStation && data.length > 0){
                    let new_worksheet = XLSX.utils.json_to_sheet(data);
                    XLSX.utils.book_append_sheet(new_workbook, new_worksheet, currentStation);
                }

                XLSX.writeFile(new_workbook, this.pdfName + ".xlsx");
            }
        },

        getCsvAllData(){
            let readings = allReadingsArray;
            if(readings.length>0){
                let data = [];
                readings.forEach((item)=>{
                    let filteredStations = this.allStations.filter((r) => r.selected);
                    if(filteredStations.length == 0 || this.all){
                        filteredStations = stationsArray;
                    }
                    let station = filteredStations.find((t) => t.station_id == item.station_id);
                    if(station && station.station_id && item.data && item.data.length > 0){
                        let readings_array = item.data.map( (reading) => {
                            let obj = {}
                            
                            obj[i18n.t('general.timeFrame')] = '';
                            obj[i18n.t('general.name')] = station.name;
                            obj[i18n.t('weatherStation.serialNumber')] = station.device_sn;
                            if(this.G_canDo(this.consts.Security.Action.SEE_LAST_READING, this.$store.state.user, null)){
                                obj[i18n.t('facility.facility')] = this.getCourseName(station);
                                let reading_date = this.G_formatDate({date: (reading.reading_time), pretty: false});
                                obj[i18n.t('general.date')] = reading_date ? reading_date.replace(/,/g, "") : reading_date;
                            }
                            
                            let temperature = this.G_getMeasurement({ val: reading.temp, uom: this.consts.UOM.TEMP, addUnit: true, invertUOM: false })
                            obj[i18n.t('alerts.airTemperature')] = temperature.replace('°', '');
                            obj[i18n.t('alerts.barometricPressure')] = this.G_getMeasurement({ val: reading.pressure, uom: this.consts.UOM.PRESSURE, addUnit: true, invertUOM: false });;
                            obj[i18n.t('alerts.vhStrike')] = this.G_getMeasurement({ val: reading.lightning_strike, uom: this.consts.UOM.UNKNOWN, addUnit: true, invertUOM: false });;
                            obj[i18n.t('alerts.precipitation')] = this.G_getMeasurement({ val: reading.precipitation, uom: this.consts.UOM.PRECIPITATION, addUnit: true, invertUOM: false });;
                            obj[i18n.t('alerts.relativeHumidity')] = this.G_getMeasurement({ val: reading.humidity, uom: this.consts.UOM.HUMIDITY, addUnit: true, invertUOM: false });;
                            obj[i18n.t('alerts.horizontalWindSpeed')] = this.G_getMeasurement({ val: reading.wind_speed, uom: this.consts.UOM.WIND_SPEED, addUnit: true, invertUOM: false });;
                            obj[i18n.t('alerts.windGust')] = this.G_getMeasurement({ val: reading.wind_gust, uom: this.consts.UOM.WIND_SPEED, addUnit: true, invertUOM: false });;
                            obj[i18n.t('alerts.eTRate')] = this.G_getMeasurement({ val: reading.et_rate, uom: this.consts.UOM.ET_RATE, addUnit: true, invertUOM: false });;
                            return obj;
                        });
                        
                        if(readings_array.length > 0){
                            data = data.concat(readings_array);
                        }
                    }
                })
                let headers = [];
                let filters = this.getHeadersObj();
                headers.push(filters);
                return [...headers, ...data];
            }
            return [];
        },

        getHeadersObj(){
            let timeFrame = this.filters.daysBack.text;
            
            let obj = {}
            obj[i18n.t('general.timeFrame')] = timeFrame;
            obj[i18n.t('general.name')] = '';
            obj[i18n.t('weatherStation.serialNumber')] = '';
            if(this.G_canDo(this.consts.Security.Action.SEE_LAST_READING, this.$store.state.user, null)){
                obj[i18n.t('facility.facility')] = '';
                obj[i18n.t('general.date')] = '';
            }
            
            obj[i18n.t('alerts.airTemperature')] = '';
            obj[i18n.t('alerts.barometricPressure')] = '';
            obj[i18n.t('alerts.vhStrike')] = '';
            obj[i18n.t('alerts.precipitation')] = '';
            obj[i18n.t('alerts.relativeHumidity')] = '';
            obj[i18n.t('alerts.horizontalWindSpeed')] = '';
            obj[i18n.t('alerts.windGust')] = '';
            obj[i18n.t('alerts.eTRate')] = '';
            
            return obj
        },

        getXLSXHeadersObj(){
            let timeFrame = this.filters.daysBack.text;
            
            let obj = {}
            obj[i18n.t('general.timeFrame')] = timeFrame;
            
            return obj
        },

        showNextPage(){
            if(this.canGetNextPage){
                this.pagination.page += 1;
                this.pagination.start += perPage;
                let newEnd = this.pagination.end + perPage;
                this.pagination.end = (this.stationsLength >= newEnd) ? newEnd : this.stationsLength;
            }
            this.getStationsByPage();
        },
        
        showPrevPage(){
            if(this.pagination.page > 1){
                this.pagination.page -= 1;
                this.pagination.start -= perPage;
                this.pagination.end = this.pagination.start + perPage - 1;
            }
            this.getStationsByPage();
        },

        getStationsByPage(){
            return this.stations.slice(this.pagination.start - 1, this.pagination.end);
        },

        filterByDays(daysBack) {
            this.options[5].value = 0
            if(this.filters.daysBack != daysBack){
                this.selectedDateRange = null;
                this.setLoadingTrue();
                this.resetValues();
                this.filters.daysBack = daysBack;
                this.getGraphs();
            }
        },

        resetValues() {
            stationsArray = [];
            validStations = [];
            this.stations = [];
            this.stationsLength = 0;
            this.temp_series = [];
            this.pressure_series = [];
            this.wind_speed_series = [];
            this.lightning_strike_series = [];
            this.precipitation_series = [];
            this.humidity_series = [];
            this.wind_gust_series = [];
            this.et_rate_series = [];
            this.pagination = {
                page: 1,
                next: false
            }
        },
        
        exportReport(){
            this.$refs.weatherStationsPDF.generatePdf();
        },

        loadData() {
            this.setLoadingTrue();
            this.loading.general = false;
            this.getGraphs();
        },

        setLoadingTrue() {
            this.loading.general = true;
            this.loading.stations = true;
            this.loading.temp = true;
            this.loading.pressure = true;
            this.loading.wind_speed = true;
            this.loading.lightning_strike = true;
            this.loading.precipitation = true;
            this.loading.humidity = true;
            this.loading.wind_gust = true;
            this.loading.et_rate = true;
        },

        async getGraphs() {
            const data = {
                courseId: this.$store.state.course.course_id
            };

            this.getCourseStations();

            this.loading.general = false;
        },

        async getCourseStations(date) {
            this.loading.stations = true;
            this.loadedSensorsArray = [];
            this.allSensorsLength = 0;
            stationsArray = [];

            const data = {
                courseId: this.$store.state.course.course_id
            };
            

            let apiCall = this.isOperationsOrAdminUser ? getAllWeatherStationsReportList : getWeatherStationsReportList;
            
            await apiCall(data).then((res) => {
                this.allStations = res.map(station => ({...station, selected: false}));
                this.loading.stations = false;
                this.stationsLength = res.length;
                this.allSensorsLength = res.length;

                if (res.length > 0) {
                    stationsArray = res;
                    
                    for(var i = 0; i < stationsArray.length; i++){
                        if(stationsArray[i].latitude != undefined && stationsArray[i].latitude != null && 
                            stationsArray[i].longitude != undefined && stationsArray[i].longitude != null && 
                            !isNaN(stationsArray[i].latitude) && !isNaN(stationsArray[i].longitude)
                        ){
                            if(this.G_validateLatLong(stationsArray[i].latitude, stationsArray[i].longitude)){
                                stationsArray[i].lat = stationsArray[i].latitude;
                                stationsArray[i].lng = stationsArray[i].longitude;
                                validStations.push(stationsArray[i]);
                            }
                        }
                    }

                    //generalData
                    this.getStationReadingsData(date);

                    let series = this.allStations.filter((r) => r.selected);
                    if(series.length == 0 || this.all){
                        series = stationsArray;
                    }
                    this.stationsLength = series.length;
                    this.pagination.start = 1;
                    this.pagination.end = (this.stationsLength >= perPage) ? perPage : this.stationsLength;
                    this.stations = series;
                    this.getStationsByPage();

                    if(this.loading.map && this.isOperationsOrAdminUser){
                        this.initMap();
                        this.loading.map = false;
                    }

                    if(this.isOperationsOrAdminUser){
                        this.stationMap();
                    }
                }

            });
            
            this.loading.stations = false;
        },

        async handleDateRangeChange(dates) {
            this.options[5].value = 0
            let date = null
            this.setLoadingTrue();
            this.resetValues();
            if(dates[0]){                
                const startDate = moment(dates[0]).format('YYYY-MM-DD')
                const endDate = moment(dates[1]).format('YYYY-MM-DD')
                const start = new Date(startDate);
                const end = new Date(endDate);
                const timeDiff = Math.abs(end.getTime() - start.getTime());
                const days = Math.ceil(timeDiff / (1000 * 3600 * 24));
                this.filters.daysBack = this.options[5] 
                this.filters.daysBack.value = days
                date = {
                startDate, 
                endDate
            };
            
            }
            await this.getCourseStations(date);
            this.loading.general = false;
        },

        async getStationReadingsData(date) {

            const daysBack = this.filters.daysBack;
            let resample = null
            if (daysBack.value == 7) {
                resample = '30min';
            } else if (daysBack.value > 7 && daysBack.value <= 30) {
                resample = '1h';
            } else if (daysBack.value > 30) {
                resample = '8h';
            }
            allReadingsArray = [];
            
            for(let index = 0; index < stationsArray.length; index++){
                
                let station = stationsArray[index];
                
                const data = {
                    device_sn: station.device_sn,
                    alias: 'all',
                    until: this.filters.daysBack.value,
                    resampleFreq: resample,
                };
                if (date){
                data['startDate'] = date.startDate
                data['endDate'] = date.endDate
                }

                let apiCall = getStationGraph;
                
                try{
                    apiCall(data).then((res) => {
                        
                        if (daysBack == this.filters.daysBack) {
                            
                            if (res.length > 0) {

                                let station_id = station.station_id;
                                let device_sn = station.device_sn;
                                let name = station.name;
                                
                                allReadingsArray.push({
                                        name: name ? name : device_sn,
                                        data: res,
                                        station_id: station_id,
                                        device_sn: device_sn
                                });
                                
                                this.getTempData(station, res, daysBack);
                                this.getPressureData(station, res, daysBack);
                                this.getHorizontalWindSpeedData(station, res, daysBack);
                                this.getLightningStrikeData(station, res, daysBack);
                                this.getPrecipitationData(station, res, daysBack);
                                this.getHumidityData(station, res, daysBack);
                                this.getWindGustData(station, res, daysBack);
                                this.getETRateData(station, res, daysBack);

                            }else{
                                this.loading.temp = false;
                                this.loading.pressure = false;
                                this.loading.wind_speed = false;
                                this.loading.lightning_strike = false;
                                this.loading.precipitation = false;
                                this.loading.humidity = false;
                                this.loading.wind_gust = false;
                                this.loading.et_rate = false;
                            }

                            this.loadedSensorsArray.push(station.station_id);
                        } else {
                            console.log('overwrite prevented for getStationReadingsData 1 ' + daysBack);
                        }

                    });
                } catch(e) {
                    this.loadedSensorsArray.push(station.station_id);
                }
            }
        },

        async getTempData(station, res, daysBack) {
            this.loading.temp = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'TEMP'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    let station_id = station.station_id;
                    let device_sn = station.device_sn;
                    let name = station.name;

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['temp'],
                                uom: 'TEMP',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.temp_series.push({
                        name: name ? name : device_sn,
                        data: tempSeries,
                        device_sn: device_sn
                    });
                }

            } else {
                console.log('overwrite prevented for  getTempData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.temperatureCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.temperatureCharOpt = tempCharOpt;
            }

            this.loading.temp = false;
        },

        async getPressureData(station, res, daysBack) {
            this.loading.pressure = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'PRESSURE'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    let station_id = station.station_id;
                    let device_sn = station.device_sn;
                    let name = station.name;

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['pressure'],
                                uom: 'PRESSURE',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.pressure_series.push({
                        name: name ? name : device_sn,
                        data: tempSeries,
                        device_sn: device_sn
                    });
                }

            } else {
                console.log('overwrite prevented for getPressureData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.pressureCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.pressureCharOpt = tempCharOpt;
            }
            this.loading.pressure = false;
        },

        async getHorizontalWindSpeedData(station, res, daysBack) {
            this.loading.wind_speed = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'WIND_SPEED'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    let station_id = station.station_id;
                    let device_sn = station.device_sn;
                    let name = station.name;

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['wind_speed'],
                                uom: 'WIND_SPEED',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.wind_speed_series.push({
                        name: name ? name : device_sn,
                        data: tempSeries,
                        device_sn: device_sn
                    });
                }

            } else {
                console.log('overwrite prevented for getHorizontalWindSpeedData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.windSpeedCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.windSpeedCharOpt = tempCharOpt;
            }
            this.loading.wind_speed = false;
        },

        async getLightningStrikeData(station, res, daysBack) {
            this.loading.lightning_strike = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'UNKNOWN'
                });

            if (daysBack == this.filters.daysBack) {
                
                let tempSeries = [];
                if (res.length > 0) {

                    let station_id = station.station_id;
                    let device_sn = station.device_sn;
                    let name = station.name;

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['lightning_strike'],
                                uom: 'UNKNOWN',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.lightning_strike_series.push({
                        name: name ? name : device_sn,
                        data: tempSeries,
                        device_sn: device_sn
                    });
                }

            } else {
                console.log('overwrite prevented for  getLightningStrikeData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.lightningStrikeCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.lightningStrikeCharOpt = tempCharOpt;
            }
            this.loading.lightning_strike = false;
        },

        async getPrecipitationData(station, res, daysBack) {
            this.loading.precipitation = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'PRECIPITATION'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    let station_id = station.station_id;
                    let device_sn = station.device_sn;
                    let name = station.name;

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['precipitation'],
                                uom: 'PRECIPITATION',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.precipitation_series.push({
                        name: name ? name : device_sn,
                        data: tempSeries,
                        device_sn: device_sn
                    });
                }

            } else {
                console.log('overwrite prevented for getPrecipitationData 1 ' + daysBack);
            }
            
            if (daysBack == this.filters.daysBack && !this.precipitationCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.precipitationCharOpt = tempCharOpt;
            }
            this.loading.precipitation = false;
        },

        async getHumidityData(station, res, daysBack) {
            this.loading.humidity = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'HUMIDITY'
                });

            if (daysBack == this.filters.daysBack) {
                
                let tempSeries = [];
                if (res.length > 0) {

                    let station_id = station.station_id;
                    let device_sn = station.device_sn;
                    let name = station.name;

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['humidity'],
                                uom: 'HUMIDITY',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.humidity_series.push({
                        name: name ? name : device_sn,
                        data: tempSeries,
                        device_sn: device_sn
                    });
                }

            } else {
                console.log('overwrite prevented for getHumidityData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.humidityCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.humidityCharOpt = tempCharOpt;
            }
            this.loading.humidity = false;
        },

        async getWindGustData(station, res, daysBack) {
            this.loading.wind_gust = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'WIND_SPEED'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    let station_id = station.station_id;
                    let device_sn = station.device_sn;
                    let name = station.name;

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['wind_gust'],
                                uom: 'WIND_SPEED',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.wind_gust_series.push({
                        name: name ? name : device_sn,
                        data: tempSeries,
                        device_sn, device_sn
                    });
                }

            } else {
                console.log('overwrite prevented for  getPressureData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.windGustCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.windGustCharOpt = tempCharOpt;
            }
            this.loading.wind_gust = false;
        },

        async getETRateData(station, res, daysBack) {
            this.loading.et_rate = true;
            
            let tempCharOpt = this.getLinesChartOptions();

            let uom = this.G_getUOM({
                    uom: 'ET_RATE'
                });

            if (daysBack == this.filters.daysBack) {
                let tempSeries = [];
                if (res.length > 0) {

                    let station_id = station.station_id;
                    let device_sn = station.device_sn;
                    let name = station.name;

                    tempSeries = res.map((item) => {
                        
                        return [
                            new Date(item.reading_time).getTime(),
                            this.G_getMeasurement({
                                val: item['et_rate'],
                                uom: 'ET_RATE',
                                addUnit: false,
                                invertUOM: false
                            })
                        ]
                        
                    });

                    this.et_rate_series.push({
                        name: name ? name : device_sn,
                        data: tempSeries,
                        device_sn, device_sn
                    });
                }

            } else {
                console.log('overwrite prevented for getETRateData 1 ' + daysBack);
            }

            if (daysBack == this.filters.daysBack && !this.etRateCharOpt.chart) {
                tempCharOpt.yaxis.title.text = uom;
                tempCharOpt.tooltip.y.formatter = (val) => {
                    return val ? `${(val).toFixed(2)}${uom}` : (val == 0 ? 0 : '');
                }

                this.etRateCharOpt = tempCharOpt;
            }
            this.loading.et_rate = false;
        },

        getLinesChartOptions() {
            return {
                chart: {
                    type: 'line',
                    animations: {
                        enabled: false,
                    },

                    stacked: false,
                    height: 350,
                    zoom: {
                        type: 'x',
                        enabled: false,
                        autoScaleYaxis: true
                    },
                    toolbar: {
                        show: false
                    },
                    events: {
                        updated: function (chartContext, config) {
                            if (CounterForUpdatesLines != 0) {
                                var elmnt = document.getElementById("chart");
                                if (elmnt) {
                                    elmnt.scrollIntoView();
                                }
                            }
                            ++CounterForUpdatesLines;
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: '',
                    align: 'left'
                },
                stroke: {
                    width: 5
                },
                yaxis: {
                    labels: {
                        formatter: function (val) {
                            return val ? (val).toFixed(2) : 0;
                        },
                    },
                    title: {
                        text: 'unitOfMeasurament'
                    },
                    min: (min) => {
                        return min - 2
                    },
                    max: (max) => {
                        return max + 2
                    },
                },
                xaxis: {
                    type: 'datetime',
                    labels: {
                        datetimeUTC: false,
                        datetimeFormatter: {
                            year: 'yyyy',
                            month: "MMM 'yy",
                            day: 'dd MMM',
                            hour: 'h:mm TT',
                        },
                    }
                },
                tooltip: {
                    x: {
                        show: true,
                        formatter: (val) => {
                            return this.G_formatDate({date: val, pretty: false});
                        }
                    },
                    shared: false,
                    y: {
                        formatter: (val) => {
                            return val ? `${(val).toFixed(2)}` : '';
                        }
                    }
                }
            }
        },

        async beforePDF({ html2pdf, options, pdfContent }){
            let container = this.$refs.reportContainer;
            let currentWidth = container.getBoundingClientRect().width;

            if(currentWidth >= pdfMaxWidth){
                this.chartMaxWidth12 = chartWidth12;
                this.chartMaxWidth6 = chartWidth6;
                this.chartMaxWidth4 = chartWidth4;
            }

            let date = new Date();
            this.pdf.date = moment(date).format("MM-DD-YYYY");
            this.pdf.time = this.filters.daysBack.text;

            this.stickyData = false;

            await html2pdf().set(options).from(pdfContent).toPdf().save();

            this.chartMaxWidth12 = "100%";
            this.chartMaxWidth6 = "100%";
            this.chartMaxWidth4 = "100%";
            this.stickyData = true;
        },
        
    },

    created() {
        let date = new Date();
        date = moment(date).format("MM-DD-YYYY");
        this.pdfName = i18n.t('reports.weatherStations') + ' ' + date;
    },

    async mounted() {
        stationsArray = [];
        this.loadedSensorsArray = [];
        allReadingsArray = [];

        if (this.$store.state.user.user_type.type_id == this.consts.UserType.ADMIN ||
              this.$store.state.user.user_type.type_id == this.consts.UserType.OPERATIONS){
            this.isOperationsOrAdminUser = true;
        }else{
            this.isOperationsOrAdminUser = false;
        }

        this.filters.daysBack = this.options[0];
        
        this.loading.map = true;
        this.loadData();
    },
};

</script>
